import React from 'react';
import { Empty } from 'seedly-component-library';
import Link from 'next/link';
import { Post } from 'entity/post/postTypes';

const RelatedPostItem = (props: { title: string; slug: string }) => {
  const { title, slug } = props;

  return (
    <div className="flex flex-col w-full gap-4">
      <Link href={`/posts/${slug}`} passHref>
        <a className="hover:underline">{title}</a>
      </Link>
      <div className="horizontal-divider" />
    </div>
  );
};

const RelatedPostList = (props: { posts: Post[] }) => {
  const { posts = [] } = props;

  const dataSource =
    posts &&
    posts.map(question => {
      const { id, slug, title } = question;
      return <RelatedPostItem key={id} slug={slug} title={title} />;
    });

  if (!dataSource || dataSource.length === 0)
    return <Empty title="No posts found." />;

  return (
    <div className="bg-white rounded p-4 h-fit">
      <div className="flex flex-col gap-2">
        <p className="text-base font-bold">Related Posts</p>
        <div className="list gap-3">{dataSource}</div>
      </div>
    </div>
  );
};

export default RelatedPostList;
